import { createContext, useContext, useState, type ReactNode } from "react";
import { HBD_IMAGE_THEMES, type HbdImageTheme } from "./theme";

interface HbdThemeCtx {
  index: number;
  setIndex: (i: number) => void;
  theme: HbdImageTheme;
}

const Ctx = createContext<HbdThemeCtx | null>(null);

/**
 * Experimental: picks a random HBD image/palette on each full page load (session-only —
 * clicking a thumbnail changes it but nothing is persisted).
 */
export function ThemeProvider({ children }: { children: ReactNode }) {
  const [index, setIndex] = useState(() => Math.floor(Math.random() * HBD_IMAGE_THEMES.length));
  const theme = HBD_IMAGE_THEMES[index];
  return <Ctx.Provider value={{ index, setIndex, theme }}>{children}</Ctx.Provider>;
}

export function useHbdTheme(): HbdThemeCtx {
  const c = useContext(Ctx);
  if (!c) throw new Error("useHbdTheme must be used within ThemeProvider");
  return c;
}
